"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const prizeInputs = [
  {
    name: "prize_uuid",
    friendlyName: "OL Prize uuid",
    type: "string",
    required: true,
  },
  {
    name: "images",
    type: "list",
    subFields: [
      {
        name: "mobile",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        required: true,
      },
      {
        name: "tablet",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        required: true,
      },
      {
        name: "desktop",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
    ],
    required: true,
  },
  {
    name: "earnPointsCtaUrl",
    friendlyName: "Earn Points CTA URL",
    type: "string",
    defaultValue: "#",
    required: true,
  },
  {
    name: "discoverButtonUrl",
    friendlyName: "Discover CTA URL",
    type: "string",
    defaultValue: "#",
    required: true,
  },
  {
    name: "loginButtonUrl",
    friendlyName: "Login CTA URL",
    type: "string",
    defaultValue: "#",
    required: true,
  },
  {
    name: "newOfferDays",
    friendlyName: "New Offer Days",
    helperText: "How many days old prize is considered new",
    type: "number",
    defaultValue: 7,
    required: true,
  },
] as const satisfies Inputs;

export const PrizeComponent: RegisteredComponent = {
  name: "Prize",
  component: dynamic(async () =>
    withValidation(prizeInputs, (await import("./Prize")).Prize, "Prize")
  ),
  inputs: prizeInputs,
};
